import { render, staticRenderFns } from "./itemDialog.vue?vue&type=template&id=01b9cf58&scoped=true"
import script from "./itemDialog.vue?vue&type=script&lang=js"
export * from "./itemDialog.vue?vue&type=script&lang=js"
import style0 from "./itemDialog.vue?vue&type=style&index=0&id=01b9cf58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9cf58",
  null
  
)

export default component.exports